import Banner from './Banner';
import BannerHOC from './BannerHOC';

export default BannerHOC(Banner);



// WEBPACK FOOTER //
// ./src/pages/Banner/index.jsx